import { useLocale, useTranslate } from '@va/localization';
import { Paragraph, ParagraphWithTooltip, fontWeights, paragraphSizes } from '@va/ui/design-system';
import { addNumberSeparator, getPercentageColors } from '@va/util/helpers';
import classNames from 'classnames';
import { isNumber } from 'lodash';
import { useMemo } from 'react';

type SessionsCountCellProps = {
  percentageChange?: number;
  sessionsCount: number;
};

export function SessionsCountCell({ percentageChange, sessionsCount }: SessionsCountCellProps) {
  const translate = useTranslate();
  const { locale } = useLocale();
  const sessionCountText = useMemo(
    () =>
      translate('sessionsCount', {
        count: addNumberSeparator(sessionsCount, locale),
      }),
    [translate, locale, sessionsCount],
  );

  return (
    <div className='flex flex-col items-end truncate'>
      <ParagraphWithTooltip
        colorClassName='text-gray-charcoal'
        weight={fontWeights.medium}
        className='whitespace-nowrap w-full'
      >
        {sessionCountText}
      </ParagraphWithTooltip>

      {isNumber(percentageChange) && (
        <Paragraph
          weight={fontWeights.medium}
          size={paragraphSizes.tiny}
          colorClassName={classNames(getPercentageColors(percentageChange, false))}
        >
          {addNumberSeparator(percentageChange, locale, {
            style: 'percent',
            signDisplay: 'exceptZero',
          })}
        </Paragraph>
      )}
    </div>
  );
}
